// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__XIxQa","overflowHidden":"Wrapper_overflowHidden__86Vts"};